module.exports = __webpack_public_path__ + "img/ic_bloc_support.3efa36e6.svg";